import React from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import BookingForm from 'components/app/bookings/travel/booking/BookingForm';

// Route-level page for New / Edit travel request.
const TravelBookingFormPage = ({ mode }) => {
  const location = useLocation();

  if (mode === 'edit') {
    return <BookingForm title="Edit travel request" booking={location.state} />;
  }

  return <BookingForm title="New travel request" />;
};

TravelBookingFormPage.propTypes = {
  mode: PropTypes.oneOf(['new', 'edit']),
};

TravelBookingFormPage.defaultProps = {
  mode: 'new',
};

export default TravelBookingFormPage;
